import './BundleAttachItem.sass';

import React, { CSSProperties, FC, memo } from 'react';

import { BundleAttachItemProps } from './BundleAttachItem.interface';
import { IcDelete28, IcGallery28, IcLock28, IcPlay28 } from '$assets';
import { aesDecrypt, classNames as cn, getFormattedTime } from '$utils';
import { AttachType } from '$store/models';

const BundleAttachItemComponent: FC<BundleAttachItemProps> = ({
  attach,
  size,
  showCoverLabel,
  duration = 0,
  onDelete,
  onClick,
  hasAccess = true,
  decryptKey,
}) => {
  const photo = (
    attach.type === AttachType.PHOTO
      ? [
          attach.photo?.photoLarge,
          attach.photo?.photoLargeEncrypted,
          attach.photo?.photoMedium,
          attach.photo?.photoMediumEncrypted,
          attach.photo?.thumbnail,
        ]
      : [attach.video?.photoLarge, attach.video?.photoMedium]
  )
    .filter(Boolean)
    .map((url) =>
      decryptKey && (url?.startsWith('http') || url?.startsWith('data:'))
        ? url
        : aesDecrypt(url, decryptKey),
    )
    .map((url) => `url(${url})`)
    .join(', ');

  return (
    <div
      style={
        {
          '--size': size && size + 'px',
          backgroundImage: photo,
        } as CSSProperties
      }
      onClick={onClick}
      className={cn('BundleAttachItem', {
        active: !!onClick,
      })}
    >
      {attach.type === AttachType.VIDEO && (
        <div className="BundleAttachItem__time">
          {getFormattedTime(attach.video?.duration || 0)}
        </div>
      )}
      {!hasAccess && (
        <div className="BundleAttachItem__blur">
          {attach.type === AttachType.PHOTO ? <IcGallery28 /> : <IcPlay28 />}
        </div>
      )}
      {hasAccess &&
        ((hasAccess && attach?.photo?.isVideo) || attach.type === AttachType.VIDEO) && (
          <div className="BundleAttachItem__play">
            <IcPlay28 />
          </div>
        )}
      {/*{duration && <div className="BundleAttachItem__duration">1:12</div>}*/}
      {onDelete && (
        <div onClick={onDelete} className="BundleAttachItem__delete">
          <IcDelete28 />
        </div>
      )}
      {!hasAccess && (
        <div className="BundleAttachItem__lock">
          <IcLock28 />
        </div>
      )}
      {showCoverLabel && <div className="BundleAttachItem__cover">Cover</div>}
    </div>
  );
};

export const BundleAttachItem = memo(BundleAttachItemComponent);
